import React, { CSSProperties } from 'react';

type IconProps = {
  w?: number;
  h?: number;
  style?: CSSProperties;
  className?: string;
  fill?: string;
};

const MetroIcon = ({ w = 24, h = 24, style, fill, className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 24 24"
      className={className}
      style={style}
      fill={fill}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM16.0395 8.56759L16.0914 8.72715L17.5914 14.7271C17.7421 15.3299 17.3756 15.9407 16.7729 16.0914C16.2203 16.2295 15.661 15.9331 15.4556 15.4185L15.4086 15.2729L14.5245 11.7405L12.9361 14.124C12.5226 14.7443 11.6467 14.7886 11.1672 14.2569L11.0639 14.124L9.474 11.7405L8.59141 15.2729C8.45328 15.8254 7.92852 16.1794 7.37774 16.1185L7.22715 16.0914C6.67461 15.9533 6.32062 15.4285 6.38153 14.8777L6.40859 14.7271L7.90859 8.72715C8.13153 7.83538 9.25088 7.59131 9.83346 8.24318L9.93606 8.37596L12 11.469L14.0639 8.37596C14.5738 7.61113 15.7101 7.75776 16.0395 8.56759Z"
        fill={fill}
      />
    </svg>
  );
};

export default MetroIcon;
